import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Link } from "react-router-dom"
import { DropTarget } from "react-dnd"
import flow from "lodash.flow"
import { moveProjectsToFolder, updateFolderTitle } from "@api/project_folders"
import { can, MODIFY_PROJECT_FOLDERS } from "@src/helpers/authorization"
import { SET_HOVERED_FOLDER } from "@src/redux/actions/project_folders"
import Title from "../shared/title"
import Posters from "./posters"

class Folder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditingTitle: false
    }
  }
  saveTitle(value) {
    this.props.updateFolderTitle(this.props.folder, value)
    this.setState({ isEditingTitle: false })
  }
  render() {
    const { folder, connectDropTarget, hoveredFolderID, canEdit } = this.props
    const addingProjectToFolder = hoveredFolderID === folder._id
    const content = (
      <div className={`projectsGroup ${addingProjectToFolder ? "shrink" :""}`}>
        <Link to={`/projects/folder/${folder.slug}`}>
          <Posters addingProjectToFolder={addingProjectToFolder} folder={folder}/>
        </Link>
        <Title
          folder
          canEdit={canEdit}
          title={folder.title}
          onFocus={e => this.setState({ isEditingTitle: true })}
          onComplete={value => this.saveTitle(value)}/>
      </div>
    )
    return connectDropTarget(content)
  }
}

const dragTarget = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  draggedFile: monitor.getItem()
})

let timeout = null
let hasHoveredOut = null

const folderTarget = {
  drop(props, monitor, component) {
    props.moveProjectsToFolder([monitor.getItem().project._id], props.folder)
  },
  hover(props, monitor, component) {
    clearTimeout(timeout)
    const currentFolderID = props.hoveredFolderID
    if (currentFolderID !== props.folder._id) {
      props.setHoveredFolder(props.folder)
    } 
    else {
      if (!hasHoveredOut) {
        props.setHoveredFolder(null)
        hasHoveredOut = true
      }
    }

    timeout = setTimeout(() => {
      props.setHoveredFolder(null)
      hasHoveredOut = true
    }, 150)
  }
}

const mapStateToProps = state => ({
  hoveredFolderID: state.projects.hoveredFolder?._id,
  canEdit: can(state.user.auth, [MODIFY_PROJECT_FOLDERS])
})

const mapDispatchToProps = dispatch => ({
  moveProjectsToFolder: bindActionCreators(moveProjectsToFolder, dispatch),
  setHoveredFolder: folder => dispatch({ type: SET_HOVERED_FOLDER, payload: { folder } }),
  updateFolderTitle: bindActionCreators(updateFolderTitle, dispatch),
})

Folder.propTypes = {
  folder: PropTypes.object.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  moveProjectsToFolder: PropTypes.func.isRequired,
  setHoveredFolder: PropTypes.func.isRequired,
  updateFolderTitle: PropTypes.func.isRequired,
  hoveredFolderID: PropTypes.string
}

export default flow(
  DropTarget("PROJECT", folderTarget, dragTarget),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Folder)
